export type SideBySidePhase =
  | 'idle'
  | 'waitingForUpload'
  | 'settingUp'
  | 'streamingCandidates'
  | 'awaitingSelection'
  | 'confirming'
  | 'completingDefault'
  | 'useSingleNote'
  | 'completed'
  | 'cancelled'
  | 'failed';

export type SideBySidePhaseEvent =
  | 'START'
  | 'UPLOAD_READY'
  | 'SETUP_MULTIPLE'
  | 'USE_SINGLE_NOTE'
  | 'STREAMS_SETTLED'
  | 'CONFIRM'
  | 'CONFIRM_FAILED'
  | 'COMPLETE_DEFAULT'
  | 'COMPLETE'
  | 'CANCEL'
  | 'FAIL'
  | 'RESET';

const transitions: Record<
  SideBySidePhase,
  Partial<Record<SideBySidePhaseEvent, SideBySidePhase>>
> = {
  idle: { START: 'waitingForUpload', RESET: 'idle' },
  waitingForUpload: {
    UPLOAD_READY: 'settingUp',
    CANCEL: 'cancelled',
    FAIL: 'failed',
    RESET: 'idle',
  },
  settingUp: {
    SETUP_MULTIPLE: 'streamingCandidates',
    USE_SINGLE_NOTE: 'useSingleNote',
    CANCEL: 'cancelled',
    FAIL: 'failed',
    RESET: 'idle',
  },
  streamingCandidates: {
    STREAMS_SETTLED: 'awaitingSelection',
    COMPLETE_DEFAULT: 'completingDefault',
    USE_SINGLE_NOTE: 'useSingleNote',
    CANCEL: 'cancelled',
    FAIL: 'failed',
    RESET: 'idle',
  },
  awaitingSelection: {
    CONFIRM: 'confirming',
    COMPLETE_DEFAULT: 'completingDefault',
    CANCEL: 'cancelled',
    FAIL: 'failed',
    RESET: 'idle',
  },
  confirming: {
    CONFIRM_FAILED: 'awaitingSelection',
    COMPLETE: 'completed',
    CANCEL: 'cancelled',
    FAIL: 'failed',
    RESET: 'idle',
  },
  completingDefault: {
    COMPLETE: 'completed',
    CANCEL: 'cancelled',
    FAIL: 'failed',
    RESET: 'idle',
  },
  useSingleNote: {
    COMPLETE: 'completed',
    CANCEL: 'cancelled',
    FAIL: 'failed',
    RESET: 'idle',
  },
  completed: { START: 'waitingForUpload', RESET: 'idle' },
  cancelled: { START: 'waitingForUpload', RESET: 'idle' },
  failed: { START: 'waitingForUpload', RESET: 'idle' },
};

export function transitionSideBySidePhase(
  phase: SideBySidePhase,
  event: SideBySidePhaseEvent
): SideBySidePhase {
  const next = transitions[phase][event];
  if (!next) {
    throw new Error(`Invalid side-by-side transition: ${phase} -> ${event}`);
  }
  return next;
}
